export const seoKeywords = {
  name: 'keywords',
  content:
    'Custom AI knowledge system, Enterprise AI knowledge management, RAG implementation services, Custom AI knowledge base development, Enterprise knowledge intelligence, AI-powered knowledge management solution, Retrieval augmented generation, Internal knowledge search AI, Enterprise document AI, Custom knowledge management system, AI knowledge retrieval',
};

export const aiKnowledgeManagementSolutionsSeo = {
  title: 'Custom Enterprise AI Knowledge Management Solution by Rumble Fish',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'Transform enterprise knowledge into competitive advantage. Rumble Fish builds custom AI knowledge management solutions with RAG technology, delivering 300-500% ROI and 30-50% productivity gains. Full ownership, no subscriptions.',
    },
  ],
};
